import React, { useState, useEffect, useRef } from "react";
import enableTableSearch from "../utility/tableSearch";
import ExportCSV from "../utility/ExportCSV";
import API_BASE_URL from "../config";
import { authFetch } from "../utility/AuthFetch";

function CategoryTable({ reload, onEdit }) {
  const [categories, setCategories] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();

  useEffect(() => {
    authFetch(API_BASE_URL + "/api/category")
      .then((res) => res.json())
      .then((data) => setCategories(data.categories))
      .catch((err) => console.error("Error fetching category:", err));
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No category found",
    });

    return cleanup;
  }, []);

  return (
    <div id="table-container">
      <div id="header">
        <p>Category List</p>
      </div>
      <hr />
      <div id="table-actions">
        <ExportCSV
          entries={categories.map((item, index) => [index + 1, item.name])}
          header={["SL. No.", "CATEGORY NAME"]}
        />
        <div className="search-box">
          <label>Search:</label>
          <input type="text" id="search" name="search" ref={inputRef} />
        </div>
      </div>
      <table id="division-table">
        <thead>
          <tr>
            <th>ACTION</th>
            <th>NAME</th>
          </tr>
        </thead>
        <tbody id="table-body" ref={tableRef}>
          {categories.map((item, index) => (
            <tr key={index}>
              <td>
                <button className="edit-btn" onClick={() => onEdit(item)}>
                  EDIT
                </button>
              </td>
              <td>{item.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CategoryTable;
